import React, { Fragment } from "react";
import MyPerformance from '../../components/ResultPage/components/MyPerformance';
import ScholarshipsOffer from '../../components/ResultPage/components/ScholarshipsOffer';
import QuestionsPerModule from "../../components/ResultPage/components/QuestionsPerModule";
import { Box, Grid, useMediaQuery } from "@mui/material";
const image = require('../../images/CTA-SIMULADO.png')

const SimulateStats = ({ data, componente }) => {


    const parseBookType = (type) => {
        switch (type) {
            case 'CIENCIAS_HUMANAS': return { name: 'Ciências humanas e suas tecnologias', icon: 'humanas' };
            case 'LINGUAGENS': return { name: 'Liguagens e códigos', icon: 'linguagens' };
            case 'CIENCIAS_DA_NATUREZA': return { name: 'Ciências da natureza e suas tecnologias', icon: 'ciencias' };
            case 'MATEMATICA': return { name: 'Matemática e suas tecnologias', icon: 'matematica' };
            default: return ''
        }
    };

    const mobile = useMediaQuery('(max-width:900px)');

    return (
        <Fragment>
            {
                componente
                &&
                <div className="wrapper">
                    <div className="vertical-large horizontal-large padded content">
                        <MyPerformance
                            data={data}
                            parseBookType={parseBookType}
                            componente={componente}
                        />
                        <section className="exam-type mt-3">
                            <div className="grid-x grid-margin-x grid-margin-y">
                                <QuestionsPerModule
                                    data={data}
                                    parseBookType={parseBookType}
                                />
                                <ScholarshipsOffer
                                    data={data}
                                />
                                <div className="small-12 cell marginb-2">
                                    <div className="restart">
                                        <button
                                            className="medium secondary button"
                                            onClick={() => data.history.push('/monte-seu-simulado')}
                                        >
                                            Fazer outro simulado
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            }
        </Fragment>
    )
};


export default SimulateStats;
